import React from 'react';
export function ComparisonTable() {
  return <div className="bg-[#0c0c0c] py-16 px-6" data-id="element-58">
      <div className="max-w-[960px] mx-auto" data-id="element-59">
        <div className="bg-gradient-to-br from-[#0a2010] to-[#0d150d] border border-brand-green/20 rounded-2xl py-11 px-9 text-center" data-id="element-60">
          <span className="inline-block bg-brand-gold/10 border border-brand-gold text-brand-gold font-display text-[11px] tracking-[2px] uppercase py-1 px-4.5 rounded mb-4.5" data-id="element-61">
            ⚡ ¿QUÉ AGREGA QUEMA X2?
          </span>
          <h2 className="font-display text-[24px] sm:text-[3.5vw] md:text-[40px] text-white mb-2 uppercase" data-id="element-62">
            🔥 <span className="text-brand-green" data-id="element-63">Quema x2</span> — El Plan de
            21 Días
          </h2>
          <p className="text-[14px] text-white/60 italic max-w-[520px] mx-auto mb-7" data-id="element-64">
            "El MegaPack te enseña el método. Quema x2 te dice exactamente qué
            comer y cómo moverte cada día durante 21 días — sin pensar, sin
            calcular, sin improvisar."
          </p>

          <div className="bg-white/5 border border-white/10 rounded-lg py-4.5 px-5.5 mb-7 text-[14px] text-white/70 italic" data-id="element-65">
            El MegaPack te da el{' '}
            <strong className="text-brand-green font-normal" data-id="element-66">
              conocimiento
            </strong>
            . Quema x2 te da el{' '}
            <strong className="text-brand-green font-normal" data-id="element-67">
              plan ya armado para ejecutar sin dudar
            </strong>
            .
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 mb-7 text-left" data-id="element-68">
            <div className="bg-white/5 border border-white/10 rounded-lg py-4.5 px-4" data-id="element-69">
              <p className="font-display text-[12px] font-bold text-brand-green mb-2 tracking-[1px] uppercase" data-id="element-70">
                📅 21 días armados
              </p>
              <ul className="list-none space-y-1.5" data-id="element-71">
                {['Menú completo día por día (4 comidas)', '3 listas de compras para el súper', 'Variantes para celíacas e intolerantes', 'Protocolo de recuperación 3 días', 'Qué hacer si comés de más'].map((item, i) => <li key={i} className="text-[12px] text-white/65 pl-3.5 relative" data-id="element-72">
                    <span className="absolute left-0 text-brand-green text-[10px]" data-id="element-73">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-lg py-4.5 px-4" data-id="element-74">
              <p className="font-display text-[12px] font-bold text-brand-green mb-2 tracking-[1px] uppercase" data-id="element-75">
                🏠 Activación en casa
              </p>
              <ul className="list-none space-y-1.5" data-id="element-76">
                {['30 ejercicios paso a paso', 'Rutinas de 15 min — 3 niveles', 'Ejercicios para panza, cola y brazos', 'Rutina de elongación nocturna', 'Qué NO hacer después de los 40'].map((item, i) => <li key={i} className="text-[12px] text-white/65 pl-3.5 relative" data-id="element-77">
                    <span className="absolute left-0 text-brand-green text-[10px]" data-id="element-78">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-lg py-4.5 px-4" data-id="element-79">
              <p className="font-display text-[12px] font-bold text-brand-green mb-2 tracking-[1px] uppercase" data-id="element-80">
                ⚡ Aceleradores
              </p>
              <ul className="list-none space-y-1.5" data-id="element-81">
                {['5 hábitos de 5 minutos que cambian todo', 'Suplementos naturales que potencian', 'Checklist de los 21 días', 'Plan de reactivación para recaídas'].map((item, i) => <li key={i} className="text-[12px] text-white/65 pl-3.5 relative" data-id="element-82">
                    <span className="absolute left-0 text-brand-green text-[10px]" data-id="element-83">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-84">
            <table className="w-full border-collapse text-[13px] text-left" data-id="element-85">
              <thead data-id="element-86">
                <tr data-id="element-87">
                  <th className="py-3 px-3.5 bg-white/5 text-brand-muted font-display tracking-[1px] uppercase text-[11px] font-medium" data-id="element-88">
                    Situación
                  </th>
                  <th className="py-3 px-3.5 bg-white/5 text-brand-muted font-display tracking-[1px] uppercase text-[11px] font-medium" data-id="element-89">
                    ❌ Solo MegaPack
                  </th>
                  <th className="py-3 px-3.5 bg-white/5 text-brand-muted font-display tracking-[1px] uppercase text-[11px] font-medium" data-id="element-90">
                    ✅ Con Quema x2
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-91">
                <tr data-id="element-92">
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-white/65" data-id="element-93">
                    Qué comer cada día
                  </td>
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-white/20" data-id="element-94">
                    Aprendés el método
                  </td>
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-brand-green font-semibold" data-id="element-95">
                    Todo armado, solo ejecutás
                  </td>
                </tr>
                <tr data-id="element-96">
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-white/65" data-id="element-97">
                    Movimiento en casa
                  </td>
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-white/20" data-id="element-98">
                    No incluido
                  </td>
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-brand-green font-semibold" data-id="element-99">
                    30 ejercicios paso a paso
                  </td>
                </tr>
                <tr data-id="element-100">
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-white/65" data-id="element-101">
                    Velocidad de resultado
                  </td>
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-white/20" data-id="element-102">
                    A tu ritmo
                  </td>
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-brand-green font-semibold" data-id="element-103">
                    Acelerado x2
                  </td>
                </tr>
                <tr data-id="element-104">
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-white/65" data-id="element-105">
                    Lista de compras semanal
                  </td>
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-white/20" data-id="element-106">
                    General
                  </td>
                  <td className="py-2.5 px-3.5 border-b border-white/5 text-brand-green font-semibold" data-id="element-107">
                    Las 3 semanas listas
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
}